import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import { teacherDeleteUser, teacherFetchUserList, teacherInsertNewStudent, teacherUpdateUser } from '../../services2/users.service';
import { teacherFetchResearchTaskRecords } from '../../services2/researchTaskRecords.service';
import * as XLSX from 'xlsx';
import { questionnaire_background } from './components/Questionnaire_background';
import { questionnaire_A1 } from './components/Questionnaire_A1_data';
import { questionnaire_A2 } from './components/Questionnaire_A2_data';
import { questionnaire_B1 } from './components/Questionnaire_B1_data';
import { questionnaire_B2 } from './components/Questionnaire_B2_data';
import { SHORT_TASK_XY } from './components/ShortTask_XY_data';
import { SHORT_TASK_YZ } from './components/ShortTask_YZ_data';
import { SHORT_TASK_ZX } from './components/ShortTask_ZX_data';
import { DATA_1 } from './components/PracticeTask_1_data';
import { DATA_2 } from './components/PracticeTask_2_data';
import { DATA_3 } from './components/PracticeTask_3_data';
import { DATA_4 } from './components/PracticeTask_4_data';
import { DATA_5 } from './components/PracticeTask_5_data';
import { DATA_6 } from './components/PracticeTask_6_data';

function Component(props) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setisLoading] = useState(false)

  const [students, setStudents] = useState([])
  const fetchStudents = async () => {
    let result = await teacherFetchUserList(props.token.token, { type: 'student' }, { limit: 9999, sort: { name: 1 } });
    if (result.result) {
      setStudents(result.result || [])
    } else {
      console.log('Fetch data error')
    }
  }

  const refresh = async () => {
    if (isLoading) return
    setisLoading(true)
    await fetchStudents()
    setisLoading(false)
  }

  useEffect(() => {
    refresh()
  }, [id])

  const handleSelectStudent = (id) => {
    setStudents(prev => prev.map(item => item._id === id ? { ...item, isSelected: !item.isSelected } : item))
  }


  const [filterName, setfilterName] = useState('')
  const [filterClass, setfilterClass] = useState('')
  const [filterGroup, setfilterGroup] = useState('')
  const filter = (list) => {
    if (!list) return []
    let result = list.filter(item => {
      if (filterName && item.name.indexOf(filterName) === -1) return false
      if (filterClass && item.class.indexOf(filterClass) === -1) return false
      if (filterGroup && item.group !== filterGroup) return false
      return true
    })
    return result
  }

  const handleDownloadData = async () => {
    setisLoading(true)
    const sheet1 = await FormatDemographicSheet()
    const sheet2 = await FormatQuestionnaireASheet()
    const sheet3 = await FormatQuestionnaireBSheet()
    const sheet4 = await FormatShortTask(SHORT_TASK_XY, ['1', '2', '11', '12'], ['7', '8', '9', '10'])
    const sheet5 = await FormatShortTask(SHORT_TASK_YZ, ['3', '4', '5', '6'], ['1', '2', '11', '12'])
    const sheet6 = await FormatShortTask(SHORT_TASK_ZX, ['7', '8', '9', '10'], ['3', '4', '5', '6'])
    const sheet7 = await FormatPracticeTask(DATA_1, ['1', '2', '3', '4'], 4)
    const sheet8 = await FormatPracticeTask(DATA_2, ['1', '2', '3', '4'], 6)
    const sheet9 = await FormatPracticeTask(DATA_3, ['5', '6', '7', '8'], 4)
    const sheet10 = await FormatPracticeTask(DATA_4, ['5', '6', '7', '8'], 6)
    const sheet11 = await FormatPracticeTask(DATA_5, ['9', '10', '11', '12'], 4)
    const sheet12 = await FormatPracticeTask(DATA_6, ['9', '10', '11', '12'], 6)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, sheet1, 'demographic')
    XLSX.utils.book_append_sheet(workbook, sheet2, '問卷 A1 A2')
    XLSX.utils.book_append_sheet(workbook, sheet3, '問卷 B1 B2')
    XLSX.utils.book_append_sheet(workbook, sheet4, '任務 X')
    XLSX.utils.book_append_sheet(workbook, sheet5, '任務 Y')
    XLSX.utils.book_append_sheet(workbook, sheet6, '任務 Z')
    XLSX.utils.book_append_sheet(workbook, sheet7, '練習任務 1')
    XLSX.utils.book_append_sheet(workbook, sheet8, '練習任務 2')
    XLSX.utils.book_append_sheet(workbook, sheet9, '練習任務 3')
    XLSX.utils.book_append_sheet(workbook, sheet10, '練習任務 4')
    XLSX.utils.book_append_sheet(workbook, sheet11, '練習任務 5')
    XLSX.utils.book_append_sheet(workbook, sheet12, '練習任務 6')
    XLSX.writeFile(workbook, 'students_data.xlsx')
    setisLoading(false)
  }

  const FormatDemographicSheet = async () => {
    const headers = ['id', '學生姓名', '班級', '電郵', '分組', '開始時間', '結束時間', '完成時間(MM:SS)']
    let pageIndex = 1
    for (let section of questionnaire_background.sections) {
      headers.push('第 ' + pageIndex + ' 頁完成所需時間（秒）')
      for (let question of section) {
        if (question.type === 'table') {
          for (let row of question.questions || []) {
            headers.push(question.title + ' ' + row.question)
          }
        } else {
          headers.push(question.question)
        }
      }
      pageIndex++
    }
    const arrayToExport = [
      headers
    ]
    for (let student of filter(students)) {
      if (student.isSelected) {
        let demographicData = await teacherFetchResearchTaskRecords(props.token.token, { studentId: student._id, session: 0, taskId: '100' }, { limit: 1 });
        let demographicArray = []
        if (demographicData.result && demographicData.result?.[0]) {

          let data = demographicData.result?.[0]?.data || {}
          demographicArray.push(new Date(demographicData.result?.[0]?.startTime || '').toLocaleString() || '')
          demographicArray.push(new Date(demographicData.result?.[0]?.submitTime || '').toLocaleString() || '')
          let total_seconds = (demographicData.result?.[0]?.submitTime - demographicData.result?.[0]?.startTime) / 1000 || 0
          demographicArray.push(Math.floor(total_seconds / 60).toString().padStart(2, '0') + ':' + Math.floor(total_seconds % 60).toString().padStart(2, '0'))//MM:SS

          for (let sectionIndex in questionnaire_background.sections) {
            let section = questionnaire_background.sections[sectionIndex]
            demographicArray.push(data?.sections?.[sectionIndex]?.[0]?.timeSpent || 0)
            for (let questionIndex in section) {
              let question = section?.[questionIndex] || {}

              if (question.type === 'table') {
                for (let rowIndex in question.questions || []) {
                  let row = question.questions[rowIndex] || {}
                  demographicArray.push(data?.sections?.[sectionIndex]?.[questionIndex]?.questions?.[rowIndex]?.answer || '')
                }
              } else if (question.type === 'single-choice') {
                if (data?.sections?.[sectionIndex]?.[questionIndex]?.answer?.includes('其他（請寫出）')) {
                  demographicArray.push((data?.sections?.[sectionIndex]?.[questionIndex]?.answer + ": " + data?.sections?.[sectionIndex]?.[questionIndex]?.answerDetail || ''))
                } else {
                  demographicArray.push(data?.sections?.[sectionIndex]?.[questionIndex]?.answer || '')
                }
              } else {
                demographicArray.push(data?.sections?.[sectionIndex]?.[questionIndex]?.answer || '')
              }
            }

          }
        }
        arrayToExport.push([student._id, student.name, student.class, student.username, student.group, ...demographicArray])
      }
    }

    const sheet1 = XLSX.utils.aoa_to_sheet(arrayToExport)
    return sheet1
  }
  const FormatQuestionnaireASheet = async () => {
    const headers = ['id', '學生姓名', '班級', '電郵', '分組', '開始時間 A1', '結束時間 A1', '完成時間A1(MM:SS)']
    let pageIndex = 1
    for (let section of questionnaire_A1.sections) {
      headers.push('第 ' + pageIndex + ' 頁完成所需時間（秒）')
      for (let question of section) {
        for (let row of question.questions || []) {
          headers.push(question.title + ' ' + row.question)
        }
      }
      pageIndex++
    }
    headers.push('開始時間 A2', '結束時間 A2', '完成時間A2(MM:SS)')
    pageIndex = 1
    for (let section of questionnaire_A2.sections) {
      headers.push('第 ' + pageIndex + ' 頁完成所需時間（秒）')
      for (let question of section) {
        for (let row of question.questions || []) {
          headers.push(question.title + ' ' + row.question)
        }
      }
      pageIndex++
    }
    const arrayToExport = [
      headers
    ]
    for (let student of filter(students)) {
      if (student.isSelected && ['1', '3', '5', '7', '9', '11'].includes(student.group)) {
        let dataA1 = await teacherFetchResearchTaskRecords(props.token.token, { studentId: student._id, session: 1, taskId: '100' }, { limit: 1 });
        let dataA2 = await teacherFetchResearchTaskRecords(props.token.token, { studentId: student._id, session: 7, taskId: '100' }, { limit: 1 });
        let dataArray = []
        if (dataA1.result && dataA1.result?.[0] && ['1', '3', '5', '7', '9', '11'].includes(dataA1.result?.[0].group)) {
          let data = dataA1.result?.[0]?.data || {}
          dataArray.push(new Date(dataA1.result?.[0]?.startTime || '').toLocaleString() || '')
          dataArray.push(new Date(dataA1.result?.[0]?.submitTime || '').toLocaleString() || '')
          let total_seconds = (dataA1.result?.[0]?.submitTime - dataA1.result?.[0]?.startTime) / 1000 || 0
          dataArray.push(Math.floor(total_seconds / 60).toString().padStart(2, '0') + ':' + Math.floor(total_seconds % 60).toString().padStart(2, '0'))//MM:SS


          for (let sectionIndex in questionnaire_A1.sections) {
            let section = questionnaire_A1.sections[sectionIndex]
            dataArray.push(data?.sections?.[sectionIndex]?.[0]?.timeSpent || 0)
            for (let questionIndex in section) {
              let question = section?.[questionIndex] || {}

              for (let rowIndex in question.questions || []) {
                dataArray.push(data?.sections?.[sectionIndex]?.[questionIndex]?.questions?.[rowIndex]?.answer || '')
              }
            }
          }
          if (dataA2.result && dataA2.result?.[0] && ['1', '3', '5', '7', '9', '11'].includes(dataA2.result?.[0].group)) {
            let data2 = dataA2.result?.[0]?.data || {}
            dataArray.push(new Date(dataA2.result?.[0]?.startTime || '').toLocaleString() || '')
            dataArray.push(new Date(dataA2.result?.[0]?.submitTime || '').toLocaleString() || '')
            let total_seconds = (dataA2.result?.[0]?.submitTime - dataA2.result?.[0]?.startTime) / 1000 || 0
            dataArray.push(Math.floor(total_seconds / 60).toString().padStart(2, '0') + ':' + Math.floor(total_seconds % 60).toString().padStart(2, '0'))//MM:SS

            for (let sectionIndex in questionnaire_A2.sections) {
              let section = questionnaire_A2.sections[sectionIndex]
              dataArray.push(data2?.sections?.[sectionIndex]?.[0]?.timeSpent || 0)
              for (let questionIndex in section) {
                let question = section?.[questionIndex] || {}

                for (let rowIndex in question.questions || []) {
                  dataArray.push(data2?.sections?.[sectionIndex]?.[questionIndex]?.questions?.[rowIndex]?.answer || '')
                }
              }
            }
          }
        }
        arrayToExport.push([student._id, student.name, student.class, student.username, student.group, ...dataArray])
      }

    }
    const sheet1 = XLSX.utils.aoa_to_sheet(arrayToExport)
    return sheet1
  }
  const FormatQuestionnaireBSheet = async () => {
    const headers = ['id', '學生姓名', '班級', '電郵', '分組', '開始時間 B1', '結束時間 B1', '完成時間A1(MM:SS)']
    let pageIndex = 1
    for (let section of questionnaire_B1.sections) {
      headers.push('第 ' + pageIndex + ' 頁完成所需時間（秒）')
      pageIndex++
      for (let question of section) {
        for (let row of question.questions || []) {
          headers.push(question.title + ' ' + row.question)
        }
      }
    }
    headers.push('開始時間 B2', '結束時間 B2', '完成時間B2(MM:SS)')
    pageIndex = 1
    for (let section of questionnaire_B2.sections) {
      headers.push('第 ' + pageIndex + ' 頁完成所需時間（秒）')
      pageIndex++
      for (let question of section) {
        for (let row of question.questions || []) {
          headers.push(question.title + ' ' + row.question)
        }
      }
    }
    const arrayToExport = [
      headers
    ]
    for (let student of filter(students)) {
      if (student.isSelected && ['2', '4', '6', '8', '10', '12'].includes(student.group)) {
        let dataA1 = await teacherFetchResearchTaskRecords(props.token.token, { studentId: student._id, session: 1, taskId: '100' }, { limit: 1 });
        let dataA2 = await teacherFetchResearchTaskRecords(props.token.token, { studentId: student._id, session: 7, taskId: '100' }, { limit: 1 });
        let dataArray = []
        if (dataA1.result && dataA1.result?.[0] && ['2', '4', '6', '8', '10', '12'].includes(dataA1.result?.[0].group)) {
          let data = dataA1.result?.[0]?.data || {}
          dataArray.push(new Date(dataA1.result?.[0]?.startTime || '').toLocaleString() || '')
          dataArray.push(new Date(dataA1.result?.[0]?.submitTime || '').toLocaleString() || '')
          let total_seconds = (dataA1.result?.[0]?.submitTime - dataA1.result?.[0]?.startTime) / 1000 || 0
          dataArray.push(Math.floor(total_seconds / 60).toString().padStart(2, '0') + ':' + Math.floor(total_seconds % 60).toString().padStart(2, '0'))//MM:SS


          for (let sectionIndex in questionnaire_B1.sections) {
            dataArray.push(data?.sections?.[sectionIndex]?.[0]?.timeSpent || 0)
            let section = questionnaire_B1.sections[sectionIndex]
            for (let questionIndex in section) {
              let question = section?.[questionIndex] || {}

              for (let rowIndex in question.questions || []) {
                dataArray.push(data?.sections?.[sectionIndex]?.[questionIndex]?.questions?.[rowIndex]?.answer || '')
              }
            }
          }
          if (dataA2.result && dataA2.result?.[0] && ['2', '4', '6', '8', '10', '12'].includes(dataA2.result?.[0].group)) {
            let data2 = dataA2.result?.[0]?.data || {}
            dataArray.push(new Date(dataA2.result?.[0]?.startTime || '').toLocaleString() || '')
            dataArray.push(new Date(dataA2.result?.[0]?.submitTime || '').toLocaleString() || '')
            let total_seconds = (dataA2.result?.[0]?.submitTime - dataA2.result?.[0]?.startTime) / 1000 || 0
            dataArray.push(Math.floor(total_seconds / 60).toString().padStart(2, '0') + ':' + Math.floor(total_seconds % 60).toString().padStart(2, '0'))//MM:SS

            for (let sectionIndex in questionnaire_B2.sections) {
              dataArray.push(data2?.sections?.[sectionIndex]?.[0]?.timeSpent || 0)
              let section = questionnaire_B2.sections[sectionIndex]
              for (let questionIndex in section) {
                let question = section?.[questionIndex] || {}

                for (let rowIndex in question.questions || []) {
                  dataArray.push(data2?.sections?.[sectionIndex]?.[questionIndex]?.questions?.[rowIndex]?.answer || '')
                }
              }
            }
          }
        }
        arrayToExport.push([student._id, student.name, student.class, student.username, student.group, ...dataArray])
      }

    }
    const sheet1 = XLSX.utils.aoa_to_sheet(arrayToExport)
    return sheet1
  }

  const FormatShortTask = async (TASK_DATA, GROUP_1, GROUP_2) => {
    const headers = ['id', '學生姓名', '班級', '電郵', '分組', '開始時間', '結束時間', '完成時間(MM:SS)']
    for (let i = 0; i < 4; i++) {
      headers.push('問題完成時間（秒）'+ TASK_DATA[i]?.question)
      headers.push(TASK_DATA[i]?.question)
      headers.push('問題得分(' + TASK_DATA[i]?.question + ')')//score
    }
    headers.push('學生總分')
    const arrayToExport = [
      headers
    ]
    for (let student of filter(students)) {
      if (student.isSelected && GROUP_1.includes(student.group)) {
        let dataA1 = await teacherFetchResearchTaskRecords(props.token.token, { studentId: student._id, session: 2, taskId: '100' }, { limit: 1 });
        let dataArray = []
        if (dataA1.result && dataA1.result?.[0] && GROUP_1.includes(dataA1.result?.[0].group)) {
          let data = dataA1.result?.[0]?.data || {}
          dataArray.push(new Date(dataA1.result?.[0]?.startTime || '').toLocaleString() || '')
          dataArray.push(new Date(dataA1.result?.[0]?.submitTime || '').toLocaleString() || '')
          let total_seconds = (dataA1.result?.[0]?.submitTime - dataA1.result?.[0]?.startTime) / 1000 || 0
          dataArray.push(Math.floor(total_seconds / 60).toString().padStart(2, '0') + ':' + Math.floor(total_seconds % 60).toString().padStart(2, '0'))//MM:SS
          let totalScore = 0
          for (let i = 0; i < 4; i++) {
            dataArray.push(data?.[i]?.timeSpent || 0) // Add the time spent on the question in seconds
            let studentAnswer = data?.[i]?.options?.filter(option => option.selected).map(option => option.text).join(', ') || ''
            dataArray.push(studentAnswer)
            let score = TASK_DATA[i]?.options?.find(option => option.correct)?.text === studentAnswer ? 1 : 0
            dataArray.push(score)
            totalScore += score
          }
          dataArray.push(totalScore)
        }
        arrayToExport.push([student._id, student.name, student.class, student.username, student.group, ...dataArray])
      }
    }
    for (let student of filter(students)) {
      if (student.isSelected && GROUP_2.includes(student.group)) {
        let dataA1 = await teacherFetchResearchTaskRecords(props.token.token, { studentId: student._id, session: 2, taskId: '100' }, { limit: 1 });
        let dataArray = []
        if (dataA1.result && dataA1.result?.[0] && GROUP_2.includes(dataA1.result?.[0].group)) {
          let data = dataA1.result?.[0]?.data || {}
          dataArray.push(new Date(dataA1.result?.[0]?.startTime || '').toLocaleString() || '')
          dataArray.push(new Date(dataA1.result?.[0]?.submitTime || '').toLocaleString() || '')
          let total_seconds = (dataA1.result?.[0]?.submitTime - dataA1.result?.[0]?.startTime) / 1000 || 0
          dataArray.push(Math.floor(total_seconds / 60).toString().padStart(2, '0') + ':' + Math.floor(total_seconds % 60).toString().padStart(2, '0'))//MM:SS
          let totalScore = 0
          for (let i = 4; i <= 7; i++) {
            dataArray.push(data?.[i]?.timeSpent || 0) // Add the time spent on the question in seconds
            let studentAnswer= data?.[i]?.options?.filter(option => option.selected).map(option => option.text).join(', ') || ''
            dataArray.push(studentAnswer)
            let score = TASK_DATA[i]?.options?.find(option => option.correct)?.text === studentAnswer ? 1 : 0
            dataArray.push(score)
            totalScore += score
          }
          dataArray.push(totalScore)
        }
        arrayToExport.push([student._id, student.name, student.class, student.username, student.group, ...dataArray])
      }
    }
    const sheet1 = XLSX.utils.aoa_to_sheet(arrayToExport)
    return sheet1
  }




  const FormatPracticeTask = async (taskData, groups, session) => {
    const headers = ['id', '學生姓名', '班級', '電郵', '分組', '開始時間', '結束時間', '完成時間(MM:SS)']
    for (let question of taskData?.questions) {
      if (question.type === '選擇題') {
        headers.push('問題完成時間（秒）' + question?.question)
        headers.push(question?.question)
      } else if (question.type === '表格問題') {
        headers.push('問題完成時間（秒）' + question?.question)
        for (let subQuestion of question?.table || []) {
          headers.push(question?.question + ' ' + subQuestion?.text)
        }
      } else if (question.type === '填寫問題') {
        headers.push('問題完成時間（秒）' + question?.question_prefix)
        headers.push(question?.question_prefix)
      } else if (question.type === '表格問題2') {
        headers.push('問題完成時間（秒）' + question?.question)
        headers.push(question?.question)
      } else if (question.type === '拖放式問題') {
        headers.push('問題完成時間（秒）' + question?.question)
        let index = 1
        for (let col of question?.dragAndDrop) {
          for (let row of col?.rows || []) {
            if (row.type === '拖放格') {
              headers.push(question.question + ' 拖放格 ' + index)
              index++
            }
          }
        }
      } else if (question.type === '短句作答題') {
        headers.push('問題完成時間（秒）' + question?.question)
        headers.push(question?.question)
      }
    }
    //score
    for (let question of taskData?.questions) {
      if (question.type === '選擇題') {
        headers.push('問題得分(' + question?.question + ')')
      } else if (question.type === '表格問題') {
        for (let subQuestion of question?.table || []) {
          headers.push('問題得分(' + question?.question + ' ' + subQuestion?.text + ')')
        }
      } else if (question.type === '填寫問題') {
        headers.push('問題得分(' + question?.question_prefix + ')')
      } else if (question.type === '表格問題2') {
        headers.push('問題得分(' + question?.question + ')')
      } else if (question.type === '拖放式問題') {
        let index = 1
        for (let col of question?.dragAndDrop) {
          for (let row of col?.rows || []) {
            if (row.type === '拖放格') {
              headers.push('問題得分(' + question.question + ' 拖放格 ' + index + ')')
              index++
            }
          }
        }
      } else if (question.type === '短句作答題') {
        headers.push('問題得分(' + question?.question + ')')
      }
    }
    headers.push('學生總分')
    //handle tabtimeSpent
    for(let tabIndex in taskData?.tabs || []){
      headers.push(`分頁${(Number(tabIndex)+1)}停留時間（秒）(${taskData?.tabs[tabIndex]?.name})`)
    }
    //handle enableEnlargeAndRecordTimeSpent
    for(let tabIndex in taskData?.tabs || []){
      for(let contentIndex in taskData?.tabs[tabIndex]?.contents || []) {
        if(taskData?.tabs[tabIndex]?.contents[contentIndex]?.type==='image' && taskData?.tabs[tabIndex]?.contents[contentIndex]?.enableEnlargeAndRecordTimeSpent) {
          headers.push(`放大停留時間（秒）(${taskData?.tabs[tabIndex]?.contents[contentIndex]?.alt})`)
          headers.push(`放大次數(${taskData?.tabs[tabIndex]?.contents[contentIndex]?.alt})`)
        }
      }
    }
    const arrayToExport = [
      headers
    ]
    for (let student of filter(students)) {
      if (student.isSelected && groups?.includes(student.group)) {
        let dataA1 = await teacherFetchResearchTaskRecords(props.token.token, { studentId: student._id, session, taskId: '100' }, { limit: 1 });
        let dataArray = []
        if (dataA1.result && dataA1.result?.[0] && groups?.includes(dataA1.result?.[0].group)) {
          let data = dataA1.result?.[0]?.data || {}
          dataArray.push(new Date(dataA1.result?.[0]?.startTime || '').toLocaleString() || '')
          dataArray.push(new Date(dataA1.result?.[0]?.submitTime || '').toLocaleString() || '')
          let total_seconds = (dataA1.result?.[0]?.submitTime - dataA1.result?.[0]?.startTime) / 1000 || 0
          dataArray.push(Math.floor(total_seconds / 60).toString().padStart(2, '0') + ':' + Math.floor(total_seconds % 60).toString().padStart(2, '0'))//MM:SS

          for (let questionIndex in taskData?.questions) {
            let question = taskData?.questions[questionIndex]
            if (question.type === '選擇題') {
              dataArray.push(data?.questions?.[questionIndex]?.timeSpent || 0)
              let studentAnswer = data?.questions?.[questionIndex]?.options?.filter(option => option.selected).map(option => option.text).join(', ') || ''
              dataArray.push(studentAnswer)
            } else if (question.type === '表格問題') {
              dataArray.push(data?.questions?.[questionIndex]?.timeSpent || 0)
              for (let subQuestionIndex in question?.table || []) {
                if (data?.questions?.[questionIndex]?.table?.[subQuestionIndex]?.answer1) {
                  dataArray.push(data?.questions?.[questionIndex]?.header[1])
                } else if (data?.questions?.[questionIndex]?.table?.[subQuestionIndex]?.answer2) {
                  dataArray.push(data?.questions?.[questionIndex]?.header[2])
                }
              }
            } else if (question.type === '填寫問題') {
              dataArray.push(data?.questions?.[questionIndex]?.timeSpent || 0)
              dataArray.push(
                (data?.questions?.[questionIndex]?.studentAnswer || '') + (data?.questions?.[questionIndex]?.studentAnswer2 ? `,${data?.questions?.[questionIndex]?.studentAnswer2}` : '')
              )
            } else if (question.type === '表格問題2') {
              dataArray.push(data?.questions?.[questionIndex]?.timeSpent || 0)
              dataArray.push(data?.questions?.[questionIndex]?.studentAnswer || '')
            } else if (question.type === '拖放式問題') {
              dataArray.push(data?.questions?.[questionIndex]?.timeSpent || 0)
              for (let colIndex in question?.dragAndDrop) {
                let col = question?.dragAndDrop?.[colIndex]
                for (let rowIndex in col?.rows || []) {
                  let row = col?.rows?.[rowIndex]
                  if (row.type === '拖放格'){
                    let studentAnswer = data?.questions?.[questionIndex]?.dragAndDrop?.[colIndex]?.rows?.[rowIndex]?.studentAnswer || ''
                    dataArray.push(studentAnswer)
                  }
                }
              }
            } else if (question.type === '短句作答題') {
              dataArray.push(data?.questions?.[questionIndex]?.timeSpent || 0)
              dataArray.push(data?.questions?.[questionIndex]?.studentAnswer || '')
            }
          }

          //score
          let totalScore = 0
          for (let questionIndex in taskData?.questions) {
            let question = taskData?.questions[questionIndex]
            if (question.type === '選擇題') {
              let studentAnswer = data?.questions?.[questionIndex]?.options?.filter(option => option.selected).map(option => option.text).join(', ') || ''
              let score =(taskData?.questions?.[questionIndex]?.options?.find(option => option.correct)?.text) === studentAnswer ? 1 : 0
              dataArray.push(score)
              totalScore += score
            } else if (question.type === '表格問題') {
              for (let subQuestionIndex in question?.table || []) {
                if (data?.questions?.[questionIndex]?.table?.[subQuestionIndex]?.answer1) {
                  let score = taskData?.questions?.[questionIndex]?.table?.[subQuestionIndex]?.correct === 1 ? 1 : 0
                  dataArray.push(score)
                  totalScore += score
                } else if (data?.questions?.[questionIndex]?.table?.[subQuestionIndex]?.answer2) {
                  let score = taskData?.questions?.[questionIndex]?.table?.[subQuestionIndex]?.correct === 2 ? 1 : 0
                  dataArray.push(score)
                  totalScore += score
                }
              }
            } else if (question.type === '填寫問題') {
              let score 
              if(taskData?.questions?.[questionIndex]?.isMultipleAnswer) {
                let answer1Correct = (data?.questions?.[questionIndex]?.studentAnswer || '') === (taskData?.questions?.[questionIndex]?.correct || '')
                let answer2Correct = (data?.questions?.[questionIndex]?.studentAnswer2 || '') === (taskData?.questions?.[questionIndex]?.correct2 || '')
                score = answer1Correct && answer2Correct ? 1 : 0
              } else {
                score = (data?.questions?.[questionIndex]?.studentAnswer || '') === (taskData?.questions?.[questionIndex]?.correct || '') ? 1 : 0
              }
              dataArray.push(score)
              totalScore += score
            } else if (question.type === '表格問題2') {
              let score = taskData?.questions?.[questionIndex]?.correct === data?.questions?.[questionIndex]?.studentAnswer || '' ? 1 : 0
              dataArray.push(score)
              totalScore += score
            } else if (question.type === '拖放式問題') {
              for (let colIndex in question?.dragAndDrop) {
                let col = question?.dragAndDrop?.[colIndex]
                for (let rowIndex in col?.rows || []) {
                  let row = col?.rows?.[rowIndex]
                  if (row.type === '拖放格'){
                    let studentAnswer = data?.questions?.[questionIndex]?.dragAndDrop?.[colIndex]?.rows?.[rowIndex]?.studentAnswer || ''
                    let score = taskData?.questions?.[questionIndex]?.dragAndDrop?.[colIndex]?.rows?.[rowIndex]?.correct === studentAnswer ? 1 : 0
                    dataArray.push(score)
                    totalScore += score
                  }
                }
              }
            } else if (question.type === '短句作答題') {
              let score = 0
              dataArray.push(score)
              totalScore += score
            }
          }
          dataArray.push(totalScore)
          let timeSpentArray = data?.tabtimeSpent || []
          for (let tabIndex in timeSpentArray) {
            dataArray.push(timeSpentArray[tabIndex] || 0)
          }

          for(let tabIndex in taskData?.tabs || []){
            for(let contentIndex in taskData?.tabs[tabIndex]?.contents || []) {
              if(taskData?.tabs[tabIndex]?.contents[contentIndex]?.type==='image' && taskData?.tabs[tabIndex]?.contents[contentIndex]?.enableEnlargeAndRecordTimeSpent) {
                dataArray.push(data?.tabs?.[tabIndex]?.contents?.[contentIndex]?.timeSpent || 0)
                dataArray.push(data?.tabs?.[tabIndex]?.contents?.[contentIndex]?.clickedTimes || 0)
              }
            }
          }
        }
        
        arrayToExport.push([student._id, student.name, student.class, student.username, student.group, ...dataArray,])
      }
    }
    const sheet1 = XLSX.utils.aoa_to_sheet(arrayToExport)
    return sheet1
  }




  const handleSelectAll = (e) => {
    const checked = e.target.checked
    setStudents(prevStudents => prevStudents.map(student => ({ ...student, isSelected: checked })))
  }

  return (
    <div className='relative h-full flex-1 bg-[#EDF5F8] flex-col flex gap-[16px] text-[16px] text-[black]  min-h-[500px] px-[16px]'>

      <div className='w-full flex flex-row gap-[48px] mt-[16px] flex-wrap justify-between items-center'>
        <div className='font-[700] text-[20px]'>學生數據</div>

      </div>

      {/*serach bar*/}
      <div className='w-full flex flex-row gap-[8px] items-center flex flex-wrap gap-[16px]'>
        <div className='font-[400]'>搜尋學生姓名:</div>
        <input value={filterName} onChange={(e) => { setfilterName(e.target.value) }} placeholder='學生姓名' className='rounded-[7px] px-[8px] py-[4px] font-[400] flex-1 max-w-[200px]' style={{ border: '1px solid black' }} />

        <div className='font-[400]'>搜尋班級:</div>
        <input value={filterClass} onChange={(e) => { setfilterClass(e.target.value) }} placeholder='班級' className='rounded-[7px] px-[8px] py-[4px] font-[400] flex-1 max-w-[200px]' style={{ border: '1px solid black' }} />

        <div className='font-[400]'>搜尋分組:</div>
        <input value={filterGroup} onChange={(e) => { setfilterGroup(e.target.value) }} placeholder='分組' className='rounded-[7px] px-[8px] py-[4px] font-[400] flex-1 max-w-[200px]' style={{ border: '1px solid black' }} />
        <div className='flex-1 flex flex-row justify-end'>
          <button onClick={handleDownloadData} className='text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#63BBD1]' style={{ background: 'linear-gradient(90deg, #178E95 0%, #07162F 100%)' }}>
            下載 Pilot Test 學生數據
          </button>
        </div>

      </div>

      {/*list of students*/}
      <div className='flex flex-col flex-1 w-full bg-[white] rounded-[10px] p-[16px] text-[14px]' style={{ overflowY: 'auto' }}>
        <div className='w-full flex flex-row justify-between font-bold py-[16px]' style={{ borderBottom: '1px solid #D1D1D1' }}>
          <div className='flex-1 flex flex-row'>
            <input type='checkbox' onChange={handleSelectAll} />
            學生姓名
          </div>
          {/* <div className='flex-1'>性別</div> */}
          <div className='flex-1'>班級</div>
          <div className='flex-1'>電郵</div>
          <div className='flex-[.5]'>分組</div>
          <div className='flex-1'>狀態</div>
          <div className='w-[64px]'></div>
        </div>
        {filter(students)?.map((item, index) =>
          <div key={item?._id || index} className='w-full flex flex-row justify-between font-[400] py-[16px] items-center' style={{ borderBottom: '1px solid #D1D1D1' }}>
            <div className='flex-1 flex flex-row gap-[4px] items-center'>
              <input type='checkbox' checked={item?.isSelected} onChange={() => handleSelectStudent(item?._id)} />
              {item?.name}
            </div>
            {/* <div className='flex-1'>{item?.gender}</div> */}
            <div className='flex-1'>{item?.class}</div>
            <div className='flex-1'>{item?.username}</div>
            <div className='flex-[.5]'>{item?.group}</div>
            <div className='flex-1 flex flex-row'>
              {item.status === 'active' ? <div className='text-[12px] rounded-[99px] px-[24px] py-[6px] bg-[#DBFFF0] text-[#4DE0A4]'>Active</div>
                : item.status === 'inactive' ? <div className='text-[12px] rounded-[99px] px-[24px] py-[6px] bg-[#FFC8C899] text-[#F06969]'>Inactive</div>
                  : <div>{item.status}</div>
              }
            </div>
            <button onClick={() => { alert('開發中') }} className='w-[64px] h-[32px] gap-[4px] rounded-[5px] flex justify-center items-center cursor-pointer hover:opacity-[.5] mr-[8px]'>
              <img src='/secondary/profile.png' alt='icon' className='w-[24px]' />
              查看
            </button>
          </div>
        )}
      </div>
      <div className='font-[700]'>總數: {filter(students)?.length}</div>
      {/*end of list of students*/}











      {isLoading && <LoadingPage />}
    </div>
  );
}

export default connect((store) => {
  return {
    token: store.tokenReducer,
  }
})(Component)
